import { atcb_init } from 'add-to-calendar-button';
import 'add-to-calendar-button/assets/css/atcb.min.css';

export default () => {
  return {
      mounted() {
        atcb_init();
      }
    }
  }